import React, {
useEffect,
useMemo,
useState,
} from "react";

import {
motion,
} from "framer-motion";

import {
Layout,
Menu,
Drawer,
Button,
Typography,
} from "antd";

import ParentAndStudentProfile from "./ParentAndStudentProfile";
import AssignmentView from "../pages/Teachers/AssignmentView";
import BioLinkProfile from "./BioLinkProfile";
import TransActionPerStudent from "../SchoolDashApp/DailyTransaction/TransActionPerStudent";
import NewNotification from "./NewNotification";

import {
MenuFoldOutlined,
MenuUnfoldOutlined,
DashboardOutlined,
UserOutlined,
ReadOutlined,
CalendarOutlined,
FileTextOutlined,
LogoutOutlined,
} from "@ant-design/icons";

import {
Box,
Grid,
Avatar,
} from "@mui/material";

import {
FaGraduationCap,
} from "react-icons/fa";

import Swal from "sweetalert2";

import api from "../api/api";

import ParentsStudentGrades from "../pages/Students/ParentsStudentGrades";

import defaultAvatar from "./maleee.jpg";

import logo from "./janareallogo.jpg";

import dashboardBanner from "./teacherss.jpg";

import {
useNavigate,
} from "react-router-dom";

const {
Header,
Sider,
Content,
} = Layout;

const {
Title,
Text,
} = Typography;

const StudentDashboard = () => {

const navigate = useNavigate();

// ============================================================
// SIDEBAR / UI STATE
// ============================================================

const [collapsed, setCollapsed] =
useState(false);

const [drawerOpen, setDrawerOpen] =
useState(false);

const [darkMode, setDarkMode] =
useState(false);

const [activePage, setActivePage] =
useState("dashboard");

// ============================================================
// STUDENT PAGE STATE
// ============================================================

const [showPayments, setShowPayments] =
useState(false);

const [showGrades, setShowGrades] =
useState(false);

const [selectedChild, setSelectedChild] =
useState(null);

// ============================================================
// USER STATE
// ============================================================

const [user, setUser] =
useState(null);

const [loading, setLoading] =
useState(true);

const [children, setChildren] =
useState([]);

const [loadingLogout, setLoadingLogout] =
useState(false);

const [tempImage, setTempImage] =
useState(null);

// ============================================================
// MOBILE STATE
// ============================================================

const [isMobile, setIsMobile] =
useState(
window.innerWidth < 768
);

// ============================================================
// WINDOW RESIZE
// ============================================================

useEffect(() => {


const resize = () => {

  setIsMobile(
    window.innerWidth < 768
  );

};


window.addEventListener(
  "resize",
  resize
);


return () => {

  window.removeEventListener(
    "resize",
    resize
  );

};


}, []);

// ============================================================
// THEME
// ============================================================

const theme = useMemo(
() => ({


  background:
    darkMode
      ? "#111827"
      : "#f5f7fb",


  sidebar:
    darkMode
      ? "#0f172a"
      : "#ffffff",


  header:
    darkMode
      ? "#111827"
      : "#ffffff",


  card:
    darkMode
      ? "#1e293b"
      : "#ffffff",


  text:
    darkMode
      ? "#ffffff"
      : "#172033",


  secondary:
    darkMode
      ? "#94a3b8"
      : "#64748b",


  border:
    darkMode
      ? "#334155"
      : "#e5e7eb",


  primary:
    "#800000",

}),
[darkMode]


);

// ============================================================
// AUTH TOKEN
// ============================================================

const token =
localStorage.getItem(
"access"
);

// ============================================================
// FETCH USER PROFILE
// ============================================================

const fetchUserProfile = async () => {


try {


  const response =
    await api.get(
      "/user-profile/",
      {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      }
    );


  setUser(
    response.data
  );


} catch (error) {


  console.error(
    "Profile error",
    error
  );


} finally {


  setLoading(false);


}


};

// ============================================================
// REFRESH USER PROFILE
// ============================================================

const refreshUser = async () => {


try {


  const response =
    await api.get(
      "/user-profile/",
      {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      }
    );


  setUser(
    response.data
  );


  setTempImage(
    null
  );


} catch (error) {


  console.error(
    "Refresh profile error",
    error
  );


}


};

// ============================================================
// FETCH LINKED STUDENTS
// ============================================================

const fetchChildren = async () => {


try {


  const response =
    await api.get(
      "/admissions/my-linked-students/",
      {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      }
    );


  const childrenData =
    Array.isArray(
      response.data
    )
      ? response.data
      : [];


  setChildren(
    childrenData
  );


} catch (error) {


  console.error(
    "Children error",
    error
  );


}


};


useEffect(() => {


fetchUserProfile();

fetchChildren();


}, []);


const handleLogout = async () => {


setLoadingLogout(
  true
);


try {


  await api.post(
    "api/logout/",
    {}
  );


} catch (error) {


  console.error(
    "Logout error",
    error
  );


} finally {


  localStorage.removeItem(
    "access"
  );


  setLoadingLogout(
    false
  );


  navigate(
    "/login"
  );


}


};


const menuItems = [

{

  key:
    "dashboard",

  icon:
    <DashboardOutlined />,

  label:
    "Dashboard",

},


{

  key:
    "assignments",

  icon:
    <FileTextOutlined />,

  label:
    "Assignments",

},


];


const childMenuItems =
children.map(
(child) => ({


    key:
      `child_${child.id}`,

    icon:
      <UserOutlined />,

    label:
      child.full_name,

  })
);

const fullMenu = [

...menuItems,


{
  type:
    "divider",
},


{

  type:
    "group",

  label:
    "My Students",

  children:
    childMenuItems,

},


];


const handleMenuClick = ({
key,
}) => {


if (
  key.startsWith(
    "child_"
  )
) {


  const id =
    key.split(
      "_"
    )[1];


  const child =
    children.find(
      (item) =>
        item.id.toString() ===
        id
    );


  setSelectedChild(
    child || null
  );


  setShowGrades(
    false
  );


  setShowPayments(
    false
  );


}


setActivePage(
  key
);


if (
  isMobile
) {


  setDrawerOpen(
    false
  );


}


};


const sidebar = (


<div
  style={{

    height:
      "100vh",

    display:
      "flex",

    flexDirection:
      "column",

    background:
      theme.sidebar,

  }}
>


  {/* ====================================================== */}
  {/* LOGO */}
  {/* ====================================================== */}

  <div
    style={{

      height:
        85,

      display:
        "flex",

      alignItems:
        "center",

      padding:
        "0 18px",

      gap:
        14,

      borderBottom:
        `1px solid ${theme.border}`,

      flexShrink:
        0,

    }}
  >


    <img
      src={logo}
      alt="School Logo"
      style={{

        width:
          48,

        height:
          48,

        borderRadius:
          14,

        objectFit:
          "cover",

        boxShadow:
          "0 8px 20px rgba(128,0,0,.25)",

      }}
    />


    {
      !collapsed && (

        <div
          style={{

            overflow:
              "hidden",

          }}
        >


          <Title
            level={5}
            style={{

              margin:
                0,

              fontSize:
                16,

              color:
                theme.text,

              fontWeight:
                800,

              lineHeight:
                1.2,

            }}
          >

            Jana L. Williams Educational Foundation School System

          </Title>


          <Text
            style={{

              fontSize:
                12,

              color:
                theme.secondary,

            }}
          >

            School Management Portal

          </Text>


        </div>

      )
    }


  </div>


  {/* ====================================================== */}
  {/* PROFILE */}
  {/* ====================================================== */}

  {
    !collapsed && (

      <div
        style={{

          padding:
            "20px 15px 10px",

          flexShrink:
            0,

        }}
      >


        <div
          style={{

            background:
              darkMode
                ? "linear-gradient(135deg,#1e293b,#0f172a)"
                : "linear-gradient(135deg,#fff,#f8fafc)",

            borderRadius:
              22,

            padding:
              18,

            textAlign:
              "center",

            border:
              `1px solid ${theme.border}`,

            boxShadow:
              "0 12px 30px rgba(0,0,0,.08)",

          }}
        >


          <ParentAndStudentProfile
            user={user}
            refreshUser={refreshUser}
            tempImage={tempImage}
            setTempImage={setTempImage}
            theme={theme}
            darkMode={darkMode}
          />


        </div>


      </div>

    )
  }


  {/* ====================================================== */}
  {/* MENU */}
  {/* ====================================================== */}

  <div
    style={{

      flex:
        1,

      overflowY:
        "auto",

      padding:
        "10px 12px",

    }}
  >


    <Menu
      mode="inline"
      items={fullMenu}
      selectedKeys={[
        activePage,
      ]}
      inlineCollapsed={
        collapsed
      }
      onClick={
        handleMenuClick
      }
      theme={
        darkMode
          ? "dark"
          : "light"
      }
      style={{

        border:
          "none",

        background:
          "transparent",

        fontWeight:
          600,

      }}
    />


  </div>


  {/* ====================================================== */}
  {/* FOOTER */}
  {/* ====================================================== */}

  <div
    style={{

      minHeight:
        60,

      display:
        "flex",

      alignItems:
        "center",

      padding:
        "0 18px",

      borderTop:
        `1px solid ${theme.border}`,

      flexShrink:
        0,

    }}
  >


    {
      !collapsed && (

        <Text
          style={{

            fontSize:
              12,

            color:
              theme.secondary,

          }}
        >

          © 2026 Jana L. Williams Educational Foundation School System

        </Text>

      )
    }


  </div>


</div>


);


const mobileSidebar = (


<div
  style={{

    height:
      "100%",

    background:
      theme.sidebar,

  }}
>

  {sidebar}

</div>


);


const sidebarWidth =
collapsed
? 75
: 270;


const drawerContent = (


<Drawer
  open={
    drawerOpen
  }
  width={
    280
  }
  placement=
    "left"
  onClose={() =>
    setDrawerOpen(
      false
    )
  }
  styles={{

    body: {

      padding:
        0,

      background:
        theme.sidebar,

    },

  }}
>

  {mobileSidebar}

</Drawer>


);


return (


<div
  style={{

    position:
      "fixed",

    top:
      0,

    left:
      0,

    right:
      0,

    bottom:
      0,

    background:
      theme.background,

    overflow:
      "hidden",

  }}
>


  <Layout
    style={{

      height:
        "100vh",

      background:
        theme.background,

    }}
  >


    {/* ====================================================== */}
    {/* DESKTOP SIDEBAR */}
    {/* ====================================================== */}

    {
      !isMobile && (

        <Sider
          width={
            sidebarWidth
          }
          collapsed={
            collapsed
          }
          collapsedWidth={
            75
          }
          style={{

            height:
              "100vh",

            position:
              "fixed",

            left:
              0,

            top:
              0,

            bottom:
              0,

            background:
              theme.sidebar,

            borderRight:
              `1px solid ${theme.border}`,

            zIndex:
              20,

            overflow:
              "hidden",

          }}
        >

          {sidebar}

        </Sider>

      )
    }


    {/* ====================================================== */}
    {/* MOBILE DRAWER */}
    {/* ====================================================== */}

    {
      isMobile &&
      drawerContent
    }


    <Layout
      style={{

        marginLeft:
          isMobile
            ? 0
            : sidebarWidth,

        height:
          "100vh",

        background:
          theme.background,

        transition:
          "margin-left .25s ease",

      }}
    >


      {/* ==================================================== */}
      {/* HEADER */}
      {/* ==================================================== */}

      <Header
        style={{

          height:
            isMobile
              ? 65
              : 75,

          padding:
            isMobile
              ? "0 12px"
              : "0 25px",

          display:
            "flex",

          alignItems:
            "center",

          justifyContent:
            "space-between",

          background:
            theme.header,

          borderBottom:
            `1px solid ${theme.border}`,

          position:
            "sticky",

          top:
            0,

          zIndex:
            10,

          boxShadow:
            "0 4px 20px rgba(0,0,0,.05)",

        }}
      >


        {/* LEFT HEADER */}

        <div
          style={{

            display:
              "flex",

            alignItems:
              "center",

            gap:
              15,

          }}
        >


          <Button
            shape="circle"
            size="large"
            icon={
              isMobile
                ? <MenuUnfoldOutlined />
                : collapsed
                ? <MenuUnfoldOutlined />
                : <MenuFoldOutlined />
            }
            onClick={() => {


              if (
                isMobile
              ) {


                setDrawerOpen(
                  true
                );


              } else {


                setCollapsed(
                  !collapsed
                );


              }


            }}
          />


          {
            !isMobile && (

              <div>


                <Typography
                  style={{

                    fontSize:
                      22,

                    fontWeight:
                      800,

                    color:
                      theme.text,

                  }}
                >

                  Student Dashboard

                </Typography>


                <Typography
                  style={{

                    fontSize:
                      12,

                    color:
                      theme.secondary,

                  }}
                >

                  School Management System

                </Typography>


              </div>

            )
          }


        </div>


        {/* RIGHT HEADER */}

        <div
          style={{

            display:
              "flex",

            alignItems:
              "center",

            gap:
              isMobile
                ? 8
                : 18,

          }}
        >


          {/* DARK MODE */}

          <Button
            shape="circle"
            onClick={() =>
              setDarkMode(
                !darkMode
              )
            }
            style={{

              background:
                darkMode
                  ? "#334155"
                  : "#f1f5f9",

              border:
                "none",

            }}
          >

            {
              darkMode
                ? "☀️"
                : "🌙"
            }

          </Button>


          {/* NOTIFICATIONS */}

          <NewNotification
            theme={theme}
            darkMode={darkMode}
            token={token}
          />


          {/* LOGOUT */}

          <Button
            danger
            shape={
              isMobile
                ? "circle"
                : "default"
            }
            icon={
              <LogoutOutlined />
            }
            loading={
              loadingLogout
            }
            onClick={
              handleLogout
            }
            style={{

              display:
                "flex",

              alignItems:
                "center",

              gap:
                8,

              fontWeight:
                700,

            }}
          >

            {
              !isMobile &&
              "Logout"
            }

          </Button>


        </div>


      </Header>


      {/* ==================================================== */}
      {/* CONTENT */}
      {/* ==================================================== */}

      <Content
        style={{

          padding:
            isMobile
              ? 12
              : 25,

          background:
            theme.background,

          height:
            isMobile
              ? "calc(100vh - 65px)"
              : "calc(100vh - 75px)",

          overflowY:
            "auto",

        }}
      >


        <motion.div

          initial={{

            opacity:
              0,

            y:
              20,

          }}

          animate={{

            opacity:
              1,

            y:
              0,

          }}

          transition={{

            duration:
              0.4,

          }}

        >


          {/* ================================================= */}
          {/* DASHBOARD */}
          {/* ================================================= */}

          {
            activePage ===
            "dashboard" && (

              <Box
                sx={{

                  display:
                    "flex",

                  flexDirection:
                    "column",

                  gap:
                    4,

                }}
              >


                <Box>

                  <BioLinkProfile
                    user={user}
                    dashboardBanner={
                      dashboardBanner
                    }
                  />

                </Box>


                <Box
                  sx={{

                    background:
                      theme.card,

                    borderRadius:
                      5,

                    padding: {

                      xs:
                        2,

                      md:
                        4,

                    },

                    boxShadow:
                      "0 15px 35px rgba(0,0,0,.08)",

                    border:
                      `1px solid ${theme.border}`,

                  }}
                >


                  <Typography
                    sx={{

                      fontWeight:
                        900,

                      fontSize:
                        22,

                      color:
                        theme.text,

                      mb:
                        3,

                    }}
                  >

                    Parent Analytics

                  </Typography>


                  <Grid
                    container
                    spacing={
                      3
                    }
                  >


                    {/* ACADEMIC PROGRESS */}

                    <Grid
                      item
                      xs={
                        12
                      }
                      md={
                        4
                      }
                    >

                      <Box
                        sx={{

                          height:
                            200,

                          borderRadius:
                            4,

                          background:
                            darkMode
                              ? "linear-gradient(135deg,#1e293b,#334155)"
                              : "linear-gradient(135deg,#fff,#f1f5f9)",

                          display:
                            "flex",

                          alignItems:
                            "center",

                          justifyContent:
                            "center",

                          flexDirection:
                            "column",

                        }}
                      >


                        <FaGraduationCap
                          style={{

                            fontSize:
                              50,

                            color:
                              "#800000",

                          }}
                        />


                        <Typography
                          sx={{

                            mt:
                              2,

                            fontWeight:
                              800,

                            color:
                              theme.text,

                          }}
                        >

                          Academic Progress

                        </Typography>


                      </Box>

                    </Grid>


                    {/* ASSIGNMENTS */}

                    <Grid
                      item
                      xs={
                        12
                      }
                      md={
                        4
                      }
                    >

                      <Box
                        sx={{

                          height:
                            200,

                          borderRadius:
                            4,

                          background:
                            darkMode
                              ? "linear-gradient(135deg,#1e293b,#334155)"
                              : "linear-gradient(135deg,#fff,#f1f5f9)",

                          display:
                            "flex",

                          alignItems:
                            "center",

                          justifyContent:
                            "center",

                          flexDirection:
                            "column",

                        }}
                      >


                        <ReadOutlined
                          style={{

                            fontSize:
                              50,

                            color:
                              "#2563eb",

                          }}
                        />


                        <Typography
                          sx={{

                            mt:
                              2,

                            fontWeight:
                              800,

                            color:
                              theme.text,

                          }}
                        >

                          Assignments

                        </Typography>


                      </Box>

                    </Grid>


                    {/* SCHOOL EVENTS */}

                    <Grid
                      item
                      xs={
                        12
                      }
                      md={
                        4
                      }
                    >

                      <Box
                        sx={{

                          height:
                            200,

                          borderRadius:
                            4,

                          background:
                            darkMode
                              ? "linear-gradient(135deg,#1e293b,#334155)"
                              : "linear-gradient(135deg,#fff,#f1f5f9)",

                          display:
                            "flex",

                          alignItems:
                            "center",

                          justifyContent:
                            "center",

                          flexDirection:
                            "column",

                        }}
                      >


                        <CalendarOutlined
                          style={{

                            fontSize:
                              50,

                            color:
                              "#16a34a",

                          }}
                        />


                        <Typography
                          sx={{

                            mt:
                              2,

                            fontWeight:
                              800,

                            color:
                              theme.text,

                          }}
                        >

                          School Events

                        </Typography>


                      </Box>

                    </Grid>


                  </Grid>


                </Box>


              </Box>

            )
          }


          {/* ================================================= */}
          {/* ASSIGNMENTS */}
          {/* ================================================= */}

          {
            activePage ===
            "assignments" && (

              <Box
                sx={{

                  background:
                    theme.card,

                  borderRadius:
                    5,

                  padding: {

                    xs:
                      2,

                    md:
                      4,

                  },

                  border:
                    `1px solid ${theme.border}`,

                  boxShadow:
                    "0 20px 40px rgba(0,0,0,.08)",

                  minHeight:
                    "80vh",

                }}
              >

                <AssignmentView />

              </Box>

            )
          }


          {/* ================================================= */}
          {/* STUDENT PROFILE */}
          {/* ================================================= */}

          {
            activePage.startsWith(
              "child_"
            ) &&
            selectedChild && (

              <Box
                sx={{

                  background:
                    darkMode
                      ? "linear-gradient(145deg,#111827,#1f2937)"
                      : "linear-gradient(145deg,#ffffff,#f8fafc)",

                  borderRadius:
                    5,

                  p: {

                    xs:
                      2,

                    sm:
                      3,

                    md:
                      4,

                  },

                  border:
                    `1px solid ${theme.border}`,

                  boxShadow:
                    darkMode
                      ? "0 20px 50px rgba(0,0,0,.35)"
                      : "0 20px 50px rgba(15,23,42,.10)",

                  position:
                    "relative",

                  overflow:
                    "hidden",

                }}
              >


                <Box
                  sx={{

                    position:
                      "absolute",

                    top:
                      0,

                    left:
                      0,

                    right:
                      0,

                    height:
                      6,

                    background:
                      "linear-gradient(90deg,#ff8400,#f97316,#14b8a6,#22c55e,#ff8400)",

                  }}
                />


                {/* STUDENT HEADER */}

                <Box
                  sx={{

                    display:
                      "flex",

                    flexDirection: {

                      xs:
                        "column",

                      md:
                        "row",

                    },

                    gap:
                      3,

                    alignItems:
                      "center",

                    mb:
                      4,

                    pt:
                      2,

                  }}
                >


                  <Box
                    sx={{

                      position:
                        "relative",

                    }}
                  >

                    <Avatar
                      src={
                        selectedChild.student_admission_image ||
                        defaultAvatar
                      }
                      sx={{

                        width: {

                          xs:
                            120,

                          sm:
                            145,

                        },

                        height: {

                          xs:
                            120,

                          sm:
                            145,

                        },

                        border:
                          "5px solid #ff8400",

                        boxShadow:
                          "0 12px 30px rgba(255,132,0,.30)",

                      }}
                    />


                    <Box
                      sx={{

                        position:
                          "absolute",

                        bottom:
                          8,

                        right:
                          8,

                        width:
                          18,

                        height:
                          18,

                        borderRadius:
                          "50%",

                        background:
                          "#22c55e",

                        border:
                          "3px solid #fff",

                      }}
                    />

                  </Box>


                  <Box
                    sx={{

                      flex:
                        1,

                      textAlign: {

                        xs:
                          "center",

                        md:
                          "left",

                      },

                    }}
                  >


                    <Typography
                      sx={{

                        fontSize: {

                          xs:
                            25,

                          sm:
                            32,

                        },

                        fontWeight:
                          900,

                        letterSpacing:
                          "-.5px",

                        color:
                          theme.text,

                        lineHeight:
                          1.2,

                      }}
                    >

                      {selectedChild.full_name}

                    </Typography>


                    <Typography
                      sx={{

                        mt:
                          0.7,

                        fontSize:
                          14,

                        fontWeight:
                          600,

                        color:
                          theme.secondary,

                      }}
                    >

                      Student Profile

                    </Typography>


                    <Box
                      sx={{

                        display:
                          "flex",

                        flexWrap:
                          "wrap",

                        gap:
                          1,

                        mt:
                          2,

                        justifyContent: {

                          xs:
                            "center",

                          md:
                            "flex-start",

                        },

                      }}
                    >


                      <Box
                        sx={{

                          px:
                            2,

                          py:
                            0.7,

                          borderRadius:
                            20,

                          background:
                            "linear-gradient(135deg,#111827,#374151)",

                          color:
                            "#fff",

                          fontSize:
                            13,

                          fontWeight:
                            800,

                        }}
                      >

                        {
                          selectedChild.grade_class_name ||
                          "N/A"
                        }

                      </Box>


                      <Box
                        sx={{

                          px:
                            2,

                          py:
                            0.7,

                          borderRadius:
                            20,

                          background:
                            "linear-gradient(135deg,#ff8400,#f97316)",

                          color:
                            "#fff",

                          fontSize:
                            13,

                          fontWeight:
                            800,

                        }}
                      >

                        Student ID: {
                          selectedChild.id ||
                          "N/A"
                        }

                      </Box>


                    </Box>


                    {/* BUTTONS */}

                    <Box
                      sx={{

                        mt:
                          2,

                        display:
                          "flex",

                        gap:
                          1.5,

                        flexWrap:
                          "wrap",

                        justifyContent: {

                          xs:
                            "center",

                          md:
                            "flex-start",

                        },

                      }}
                    >


                      <Button
                        onClick={() => {

                          setShowPayments(
                            false
                          );

                          setShowGrades(
                            true
                          );

                        }}
                        style={{

                          padding:
                            "9px 20px",

                          borderRadius:
                            10,

                          fontWeight:
                            800,

                          background:
                            "linear-gradient(135deg,#ff8400,#f97316)",

                          color:
                            "#fff",

                          border:
                            "none",

                        }}
                      >

                        View Grades

                      </Button>


                      <Button
                        onClick={() => {

                          setShowGrades(
                            false
                          );

                          setShowPayments(
                            true
                          );

                        }}
                        style={{

                          padding:
                            "9px 20px",

                          borderRadius:
                            10,

                          fontWeight:
                            800,

                          background:
                            "linear-gradient(135deg,#1565c0,#42a5f5)",

                          color:
                            "#fff",

                          border:
                            "none",

                        }}
                      >

                        Payment Transactions

                      </Button>


                    </Box>


                  </Box>


                </Box>


                {/* =========================================== */}
                {/* GRADES */}
                {/* =========================================== */}

                {
                  showGrades ? (

                    <ParentsStudentGrades
                      selectedChild={
                        selectedChild
                      }
                      onBack={() => {

                        setShowGrades(
                          false
                        );

                      }}
                    />

                  )


                  /* ========================================= */
                  /* PAYMENTS */
                  /* ========================================= */

                  : showPayments ? (

                    <Box
                      sx={{

                        background:
                          theme.card,

                        borderRadius:
                          5,

                        p: {

                          xs:
                            2,

                          md:
                            4,

                        },

                        border:
                          `1px solid ${theme.border}`,

                        boxShadow:
                          "0 20px 40px rgba(0,0,0,.08)",

                      }}
                    >


                      <Button
                        onClick={() =>
                          setShowPayments(
                            false
                          )
                        }
                        style={{

                          marginBottom:
                            20,

                          borderRadius:
                            10,

                          fontWeight:
                            800,

                          background:
                            "linear-gradient(135deg,#800000,#b91c1c)",

                          color:
                            "#fff",

                          border:
                            "none",

                        }}
                      >

                        ← Back to Student Overview

                      </Button>


                      <TransActionPerStudent
                        selectedChild={
                          selectedChild
                        }
                        onBack={() =>
                          setShowPayments(
                            false
                          )
                        }
                      />


                    </Box>

                  )


                  /* ========================================= */
                  /* STUDENT OVERVIEW */
                  /* ========================================= */

                  : (

                    <Grid
                      container
                      spacing={
                        3
                      }
                    >


                      {/* ATTENDANCE */}

                      <Grid
                        item
                        xs={
                          12
                        }
                        md={
                          6
                        }
                      >

                        <Box
                          sx={{

                            p:
                              3,

                            height:
                              "100%",

                            borderRadius:
                              4,

                            background:
                              darkMode
                                ? "linear-gradient(145deg,#1f2937,#111827)"
                                : "#ffffff",

                            border:
                              `1px solid ${theme.border}`,

                            boxShadow:
                              "0 10px 25px rgba(15,23,42,.05)",

                          }}
                        >


                          <Typography
                            sx={{

                              fontWeight:
                                900,

                              fontSize:
                                18,

                              color:
                                theme.text,

                              mb:
                                2.5,

                            }}
                          >

                            Attendance Summary

                          </Typography>


                          <Grid
                            container
                            spacing={
                              1.5
                            }
                          >


                            <Grid
                              item
                              xs={
                                4
                              }
                            >

                              <Box
                                sx={{

                                  textAlign:
                                    "center",

                                  p:
                                    2,

                                  borderRadius:
                                    3,

                                  background:
                                    darkMode
                                      ? "rgba(34,197,94,.12)"
                                      : "#ecfdf5",

                                }}
                              >

                                <Typography
                                  sx={{

                                    fontSize:
                                      11,

                                    fontWeight:
                                      700,

                                    color:
                                      "#22c55e",

                                  }}
                                >

                                  Present

                                </Typography>


                                <Typography
                                  sx={{

                                    fontSize:
                                      26,

                                    fontWeight:
                                      900,

                                    color:
                                      "#22c55e",

                                  }}
                                >

                                  {
                                    selectedChild.total_present ||
                                    0
                                  }

                                </Typography>


                              </Box>

                            </Grid>


                            <Grid
                              item
                              xs={
                                4
                              }
                            >

                              <Box
                                sx={{

                                  textAlign:
                                    "center",

                                  p:
                                    2,

                                  borderRadius:
                                    3,

                                  background:
                                    darkMode
                                      ? "rgba(239,68,68,.12)"
                                      : "#fef2f2",

                                }}
                              >

                                <Typography
                                  sx={{

                                    fontSize:
                                      11,

                                    fontWeight:
                                      700,

                                    color:
                                      "#ef4444",

                                  }}
                                >

                                  Absent

                                </Typography>


                                <Typography
                                  sx={{

                                    fontSize:
                                      26,

                                    fontWeight:
                                      900,

                                    color:
                                      "#ef4444",

                                  }}
                                >

                                  {
                                    selectedChild.total_absent ||
                                    0
                                  }

                                </Typography>


                              </Box>

                            </Grid>


                            <Grid
                              item
                              xs={
                                4
                              }
                            >

                              <Box
                                sx={{

                                  textAlign:
                                    "center",

                                  p:
                                    2,

                                  borderRadius:
                                    3,

                                  background:
                                    darkMode
                                      ? "rgba(255,132,0,.12)"
                                      : "#fff7ed",

                                }}
                              >

                                <Typography
                                  sx={{

                                    fontSize:
                                      11,

                                    fontWeight:
                                      700,

                                    color:
                                      "#ff8400",

                                  }}
                                >

                                  Late

                                </Typography>


                                <Typography
                                  sx={{

                                    fontSize:
                                      26,

                                    fontWeight:
                                      900,

                                    color:
                                      "#ff8400",

                                  }}
                                >

                                  {
                                    selectedChild.total_late ||
                                    0
                                  }

                                </Typography>


                              </Box>

                            </Grid>


                          </Grid>


                        </Box>

                      </Grid>


                      {/* FEES */}

                      <Grid
                        item
                        xs={
                          12
                        }
                        md={
                          6
                        }
                      >

                        <Box
                          sx={{

                            p:
                              3,

                            height:
                              "100%",

                            borderRadius:
                              4,

                            background:
                              darkMode
                                ? "linear-gradient(145deg,#1f2937,#111827)"
                                : "#ffffff",

                            border:
                              `1px solid ${theme.border}`,

                          }}
                        >


                          <Typography
                            sx={{

                              fontWeight:
                                900,

                              fontSize:
                                18,

                              color:
                                theme.text,

                              mb:
                                2.5,

                            }}
                          >

                            Fees Information

                          </Typography>


                          <Box
                            sx={{

                              display:
                                "flex",

                              justifyContent:
                                "space-between",

                              p:
                                1.5,

                              mb:
                                1,

                              borderRadius:
                                2,

                              background:
                                darkMode
                                  ? "rgba(255,255,255,.04)"
                                  : "#f8fafc",

                            }}
                          >

                            <Typography
                              sx={{

                                color:
                                  theme.secondary,

                                fontWeight:
                                  600,

                              }}
                            >

                              Total Fee

                            </Typography>


                            <Typography
                              sx={{

                                fontWeight:
                                  900,

                                color:
                                  theme.text,

                              }}
                            >

                              $
                              {
                                Number(
                                  selectedChild.total_fee ||
                                  0
                                ).toLocaleString(
                                  "en-US"
                                )
                              }

                            </Typography>


                          </Box>


                          <Box
                            sx={{

                              display:
                                "flex",

                              justifyContent:
                                "space-between",

                              p:
                                1.5,

                              mb:
                                1,

                              borderRadius:
                                2,

                              background:
                                darkMode
                                  ? "rgba(34,197,94,.08)"
                                  : "#f0fdf4",

                            }}
                          >

                            <Typography
                              sx={{

                                color:
                                  theme.secondary,

                                fontWeight:
                                  600,

                              }}
                            >

                              Amount Paid

                            </Typography>


                            <Typography
                              sx={{

                                fontWeight:
                                  900,

                                color:
                                  "#16a34a",

                              }}
                            >

                              $
                              {
                                Number(
                                  selectedChild.amount_paid ||
                                  0
                                ).toLocaleString(
                                  "en-US"
                                )
                              }

                            </Typography>


                          </Box>


                          <Box
                            sx={{

                              display:
                                "flex",

                              justifyContent:
                                "space-between",

                              p:
                                1.5,

                              borderRadius:
                                2,

                              background:
                                darkMode
                                  ? "rgba(239,68,68,.08)"
                                  : "#fef2f2",

                            }}
                          >

                            <Typography
                              sx={{

                                color:
                                  theme.secondary,

                                fontWeight:
                                  600,

                              }}
                            >

                              Balance

                            </Typography>


                            <Typography
                              sx={{

                                fontWeight:
                                  900,

                                color:
                                  "#ef4444",

                              }}
                            >

                              $
                              {
                                Number(
                                  selectedChild.balance_fee ||
                                  0
                                ).toLocaleString(
                                  "en-US"
                                )
                              }

                            </Typography>


                          </Box>


                        </Box>

                      </Grid>


                      {/* COMPLAINTS */}

                      <Grid
                        item
                        xs={
                          12
                        }
                      >

                        <Box
                          sx={{

                            p:
                              3,

                            borderRadius:
                              4,

                            background:
                              darkMode
                                ? "linear-gradient(145deg,#1f2937,#111827)"
                                : "#ffffff",

                            border:
                              `1px solid ${theme.border}`,

                          }}
                        >


                          <Box
                            sx={{

                              display:
                                "flex",

                              justifyContent:
                                "space-between",

                              alignItems:
                                "center",

                              mb:
                                2.5,

                            }}
                          >

                            <Typography
                              sx={{

                                fontSize:
                                  20,

                                fontWeight:
                                  900,

                                color:
                                  theme.text,

                              }}
                            >

                              Complaints

                            </Typography>


                            <Box
                              sx={{

                                px:
                                  1.5,

                                py:
                                  0.5,

                                borderRadius:
                                  20,

                                fontSize:
                                  12,

                                fontWeight:
                                  800,

                                background:
                                  "#fff7ed",

                                color:
                                  "#c2410c",

                              }}
                            >

                              {
                                selectedChild.complaints?.length ||
                                0
                              }

                            </Box>


                          </Box>


                          {
                            selectedChild.complaints &&
                            selectedChild.complaints.length > 0

                              ? (

                                selectedChild.complaints.map(
                                  (item) => (

                                    <Box
                                      key={
                                        item.id
                                      }
                                      sx={{

                                        p:
                                          2,

                                        mb:
                                          1.5,

                                        borderRadius:
                                          3,

                                        background:
                                          darkMode
                                            ? "rgba(255,255,255,.04)"
                                            : "#f8fafc",

                                        borderLeft:
                                          "4px solid #ff8400",

                                        border:
                                          `1px solid ${theme.border}`,

                                        borderLeftWidth:
                                          4,

                                      }}
                                    >


                                      <Typography
                                        sx={{

                                          fontWeight:
                                            800,

                                          fontSize:
                                            15,

                                          color:
                                            theme.text,

                                          mb:
                                            0.5,

                                        }}
                                      >

                                        {item.title}

                                      </Typography>


                                      <Typography
                                        sx={{

                                          color:
                                            theme.secondary,

                                          fontSize:
                                            14,

                                          lineHeight:
                                            1.6,

                                        }}
                                      >

                                        {item.description}

                                      </Typography>


                                    </Box>

                                  )
                                )

                              )

                              : (

                                <Box
                                  sx={{

                                    py:
                                      4,

                                    textAlign:
                                      "center",

                                    borderRadius:
                                      3,

                                    background:
                                      darkMode
                                        ? "rgba(255,255,255,.03)"
                                        : "#f8fafc",

                                  }}
                                >

                                  <Typography
                                    sx={{

                                      color:
                                        theme.secondary,

                                      fontSize:
                                        14,

                                    }}
                                  >

                                    No complaints found

                                  </Typography>

                                </Box>

                              )
                          }


                        </Box>

                      </Grid>


                    </Grid>

                  )
                }


              </Box>

            )
          }


        </motion.div>


      </Content>


    </Layout>


  </Layout>


</div>

);

};

export default StudentDashboard;
